import { BreadcrumbLink } from '../../app/shared/interfaces/breadcrumb-link.interface'

export const appBreadcrumbLinks: { [key: string]: BreadcrumbLink[] } = {
  // About dropdown.
  about: [{ label: 'À propos' }],
  networkOfExperts: [{ label: 'Réseau des Experts en IA de l’OCDE' }],
  partners: [{ label: 'Partenaires' }],
  resources: [{ label: 'Ressources' }],
  FAQ: [{ label: 'FAQ' }],
  videos: [{ label: 'Vidéos' }],
  survey: [{ label: 'Questionnaire' }],
  classificationSurvey: [
    { label: `Questionnaire pour la classification des systèmes d'IA` }
  ],

  // AI Principles dropdown.
  principleList: [
    {
      label:
        'Présentation des Principes sur l’Intelligence Artificielle de l’OCDE'
    }
  ],
  principleDetail: [
    {
      label: 'Principes sur l’Intelligence Artificielle de l’OCDE',
      path: 'ai-principles'
    }
  ],

  // Policy areas.
  policyAreaList: [
    {
      label:
        'Présentation des différents domaines de politique publique affectés par l’IA'
    }
  ],
  policyAreaDetail: [{ label: 'Politiques publiques', path: 'policy-areas' }],

  // Trends and data.
  trendsAndData: [{ label: 'Présentation des tendances et données ' }],
  OECDMetricsAndMethods: [{ label: 'Mesures et méthodes de l’OCDE' }],
  liveDataFromPartners: [{ label: 'Données en temps réel' }],

  // Dashboards.
  countriesAndInitiatives: [],
  stakeholderInitiativeList: [
    {
      label: 'Pays & Initiatives',
      path: 'countries-and-tools'
    },
    { label: 'Stakeholder initiatives' }
  ],
  mainDashboard: [
    {
      label: 'Pays & Initiatives',
      path: 'countries-and-tools'
    },
    {
      label: 'Stratégies nationales et politiques publiques ',
      path: 'dashboards'
    }
  ],
  search: [
    {
      label: 'Recherche',
      path: 'search'
    }
  ],

  // Blog.
  blogIndex: [{ label: 'Le Blog du AI Wonk', path: 'wonk' }],
  blogAuthors: [{ label: 'Experts en IA', path: 'community' }],

  // Pages
  pages: [{ label: 'Pages' }],
  wips: [
    {
      label: 'Work, Innovation, Productivity and Skills programme',
      path: '/work-innovation-productivity-skills/'
    }
  ],

  // Gov
  aiInGov: [
    {
      label: 'AI in governments',
      path: 'gov'
    }
  ],

  // Other
  events: [{ label: 'Événements' }],
  contact: [{ label: 'Contact' }],
  error404: [{ label: 'Erreur 404 : Page non trouvée' }]
}

// Home breadcrumb link is the root of all others.
export const homeBreadcrumbLink: BreadcrumbLink = {
  label: 'Accueil',
  path: '/'
}
